import {
  Calendar,
  Divider,
  Drawer,
  Flex,
  FloatButton,
  Timeline,
} from "antd";
import { ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";
import { useCalendarIssues } from "components/CalendarIssues/context";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import getTaskStatusColor from "helpers/getTaskStatusColor";
import Typography from "antd/es/typography/Typography";

const AsidePanel = () => {
  const {
    is_open_aside_panel,
    is_loading_tasks,
    calendar_date,
    setCalendarDate,
    setOpenAsidePanel,
    tasks,
    view_type,
  } = useCalendarIssues();
  const [date, setDate] = useState(calendar_date);

  const onDateChange = (value, selectInfo) => {
    setDate(value);
    if (selectInfo.source === "date") {
      setCalendarDate(value);
    }
  };

  useEffect(() => {
    setDate(calendar_date);
  }, [calendar_date]);

  const items = useMemo(() => {
    return tasks
      .filter(({ date }) => dayjs(calendar_date).isSame(dayjs(date), "day"))
      .map(({ content, date, status_color, is_completed }) => ({
        color: getTaskStatusColor(status_color),
        children: (
          <Flex justify="space-between" wrap>
            <Typography.Text delete={is_completed}>
              {[dayjs(date).format("DD-MM HH:mm"), content].join(" - ")}
            </Typography.Text>
            {is_completed && <CheckOutlined />}
          </Flex>
        ),
      }));
  }, [tasks, calendar_date]);

  return (
    <>
      <Drawer
        closable={{ "aria-label": "Close Button" }}
        onClose={() => setOpenAsidePanel(false)}
        destroyOnHidden
        placement="right"
        open={is_open_aside_panel}
      >
        <Divider orientation="left" size="small">
          Kalendarz
        </Divider>
        <Calendar
          fullscreen={false}
          value={dayjs(date)}
          mode="month"
          onSelect={onDateChange}
        />
        <Divider orientation="left" size="small">
          Priorytety
        </Divider>
        <Timeline
          pending={is_loading_tasks}
          mode="left"
          items={items}
          style={{ marginTop: 50 }}
        />
      </Drawer>
      {["day", "week"].includes(view_type) && !is_open_aside_panel && (
        <FloatButton
          icon={<ArrowLeftOutlined />}
          type="primary"
          tooltip="Wysuń panel boczny"
          style={{ insetInlineEnd: 80 }}
          onClick={() => setOpenAsidePanel(true)}
        />
      )}
    </>
  );
};

export default AsidePanel;
